export default __webpack_public_path__ + "static/media/spreadsheet-id.3133f048.png";